import { useEffect } from "react";
import { Iprefix as IPrefix } from "src/hooks/useTranslation";
import { useZusTranslatePrefixStore } from "src/zustand/store";

const useUpdateTranslatePrefix = (translatePrefix: IPrefix) => {
  const { setTranslatePrefix } = useZusTranslatePrefixStore();

  useEffect(
    () => setTranslatePrefix(translatePrefix),
    [setTranslatePrefix, translatePrefix]
  );
};

export default useUpdateTranslatePrefix;
